
import FAQAccordion from '../../../components/base/FAQAccordion';
import { landscapingFaqs } from '../../../mocks/faqs';

const LandscapingFAQ = () => {
  return (
    <div>
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        Landscaping FAQs
      </h2>
      <p className="text-gray-600 text-lg mb-8 leading-relaxed">
        Common questions about our landscaping and garden services in Durban and KZN
      </p>

      <FAQAccordion faqs={landscapingFaqs} />
    </div>
  );
};

export default LandscapingFAQ;
